// src/chat/chatApi.js
// کلاینت مستقل چت — توکن چت جدا از توکن برنامه نگهداری می‌شود.

const TOKEN_KEY = 'jam_chat_token';
const USER_KEY  = 'jam_chat_user';

export function getChatToken() {
  return localStorage.getItem(TOKEN_KEY) || '';
}
export function getChatUser() {
  try { return JSON.parse(localStorage.getItem(USER_KEY) || 'null'); }
  catch { return null; }
}
export function setChatSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}
export function clearChatSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export async function chatLogin(username, password) {
  const res = await fetch('/api/chat/login/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  const data = await res.json().catch(() => ({ ok: false, msg: 'پاسخ نامعتبر سرور' }));
  if (data.ok) setChatSession(data.token, data.user);
  return data;
}

export async function fetchMessages(screenKey) {
  const res = await fetch(`/api/chat/messages/?screen=${encodeURIComponent(screenKey)}`, {
    headers: { 'X-Chat-Token': getChatToken() },
  });
  if (res.status === 401) return { ok: false, unauth: true };
  return res.json().catch(() => ({ ok: false, msg: 'پاسخ نامعتبر سرور' }));
}

export async function postMessage({ screenKey, body, parentId, files }) {
  const fd = new FormData();
  fd.append('screen', screenKey);
  fd.append('body', body || '');
  if (parentId) fd.append('parent_id', String(parentId));
  (files || []).forEach(f => fd.append('images', f));

  const res = await fetch('/api/chat/messages/', {
    method: 'POST',
    headers: { 'X-Chat-Token': getChatToken() },  // بدون Content-Type تا boundary خودکار ست شود
    body: fd,
  });
  if (res.status === 401) return { ok: false, unauth: true };
  return res.json().catch(() => ({ ok: false, msg: 'پاسخ نامعتبر سرور' }));
}

// آدرس تصویر برای <img src> — توکن به‌صورت query چون <img> هدر نمی‌فرستد
export function attachmentUrl(id) {
  return `/api/chat/attachments/${id}/?t=${encodeURIComponent(getChatToken())}`;
}
